import React from "react";
import { Navigate } from "react-router-dom";

// Beskyttede ruter for innloggede brukere
const PrivateRoute = ({ children }) => {
  const authToken = localStorage.getItem("authToken"); // Sjekk om authToken eksisterer
  return authToken ? children : <Navigate to="/login" replace />;
};

export default PrivateRoute;